"use strict";
const EMPTY_STYLES = Object.freeze({});
const EMPTY_SLOT_STYLES = Object.freeze(
  {}
);

export { EMPTY_SLOT_STYLES, EMPTY_STYLES };
